import React from 'react';
import Skeleton from 'react-skeleton-loader';

// Placeholder(s) sized to match DisplayCounter, shown while its data loads.
const DisplayCounterSkeleton = ({ count = 1, small = false }) =>
  Array.from({ length: count }).map((_, index) => (
    <div
      key={index}
      style={{ display: 'inline-block', marginRight: 10, marginBottom: 10 }}
    >
      <Skeleton
        width={`${small ? 190 : 270}px`}
        height={`${small ? 96 : 156}px`}
        borderRadius={small ? '10px' : '12px'}
      />
    </div>
  ));

export default DisplayCounterSkeleton;
